// extracted by mini-css-extract-plugin
export default {"cls1":"rgJTenV5mC1I06FnNGKV","cls2":"igGueGPxlBYSLic7Le04 rgJTenV5mC1I06FnNGKV"};